import adminDatagrid from './admin-datagrid/admin-datagrid.js';
import eventFunction from './event-function/event-function.js';
import loadingSpinner from './loading-spinner/loading-spinner.js';

let ComponentsModule = angular.module('admin-components', [
    adminDatagrid,
    eventFunction,
    loadingSpinner
])
    .name;

export default ComponentsModule;



// WEBPACK FOOTER //
// ./src/app/angular/admin-portal.components.js